export const ATTENTION_TYPES = ['brand', 'guide', 'high', 'medium', 'neutral', 'positive'] as const;
export type AttentionType = (typeof ATTENTION_TYPES)[number];
